import PropTypes from 'prop-types';
import React from 'react';
import './BottomSheet.sass';

const BottomSheet = ({ color, border, className, ref, allowOverflow, padding, children, primaryButton }) => {
	const style = !color
		? {}
		: {
			background: color,
			border: border ? '1rem solid rgba(0, 0, 0, 0.1)' : '',
			borderStyle: border ? 'solid solid none solid' : '',
			color: 'white',
		};

	return (
		<div className="bottomsheet__wrapper">
			<div className="bottomsheet__container">
				<section
					className={['bottomsheet bg-white relative text-left w-full max-w-2xl mx-auto', className].join(' ')}
					style={style}
					ref={ref}>
					{primaryButton}
					<div className={allowOverflow ? 'overflow-visible' : 'overflow-hidden'}>
						<div
							className={`${allowOverflow ? 'overflow-y-visible' : 'overflow-y-auto'} overflow-x-visible h-full${padding ? ' p-4' : ''}`}>
							{children}
						</div>
					</div>
				</section>
			</div>
		</div>
	);
};

BottomSheet.propTypes = {
	allowOverflow: PropTypes.bool,
	border: PropTypes.bool,
	children: PropTypes.any.isRequired,
	className: PropTypes.string,
	color: PropTypes.string,
	padding: PropTypes.bool,
	primaryButton: PropTypes.any,
	ref: PropTypes.any,
}

BottomSheet.defaultProps = {
	allowOverflow: undefined,
	border: undefined,
	className: undefined,
	color: undefined,
	padding: undefined,
	primaryButton: undefined,
	ref: undefined,
}

export default BottomSheet;
